import { UIComponent, UILayout } from "@aptus/frontend-core";
import { Button, TextField } from "@mui/material";
import { Footer } from "components/footer";
import i18next from "i18next";
import { FullScreenForm } from "style/fullScreenForm";
import { MileageFormLayoutProps, MileageFormProps, useMileageForm } from "./useMileageForm";

const Layout: UILayout<MileageFormLayoutProps> = ({
	submit, register, errors, isValid,
}) => (
	<form onSubmit={submit} style={{ width: "100%", height: "100%" }}>
		<FullScreenForm>
			<main>
				<TextField
					{...register("mileage")}
					type="number"
					label={i18next.t("mileageForm.mileage")}
					error={!!errors.mileage}
					helperText={errors.mileage?.message}
				/>
			</main>
			<Footer>
				<Button
					type="submit"
					disabled={!isValid}
					fullWidth
				>
					{i18next.t("mileageForm.submit")}
				</Button>
			</Footer>
		</FullScreenForm>
	</form>
);

export const MileageForm: UIComponent<MileageFormProps> = (props) => (
	<Layout {...props} {...useMileageForm(props)} />
);
